import MainHome from "./index.vue";

export default {
  path: "/",
  name: "MainHome",
  component: MainHome,
  meta: {
    label: "主页",
  },
};
